export default __webpack_public_path__ + "static/termos-de-uso-wecharge-6b2091ad79f75ba11f2dd0253a7c306b.pdf";